<template>
    <tr :class="[isDisabledChannel(channel) && 'disabled']" :key="channel.id" @mouseenter="handleMouseEnter" @mouseleave="handleMouseLeave">
        <td class="cell__checkbox">
            <div class="form-checkbox">
                <input type="checkbox" :id="`channel_${channel.id}`" :value="true" v-model="channel.selected" >
                <label :for="`channel_${channel.id}`"></label>
            </div>
        </td>
        <td><span class="text__customer_code">{{ channel.key }}</span></td>
        <td>{{ channel.customer_code }}</td>
        <td v-tooltip="isDisabledChannel(channel) ? {content: $t('paragraphs.channel.not_available_desc'), classes: ['tooltip--long'], html:true, placement: 'bottom', boundariesElement: 'window', show: showTooltip, trigger: 'manual'} : false">
            <i :class="{'': channel.is_shared, 'icon icon-lock': !channel.is_shared}"></i>
            <router-link :to="{ name: 'cms-channels-view', params: { channel_id: channel.id } }" class="list__channel__name text-link" :title="channel.title">
                {{ channel.title }}{{ isDisabledChannel(channel) ?  `(${$t('words.channel_not_available')})` : '' }}
            </router-link>
        </td>
        <td class="td__number">
            <span v-if="channel.ended_live_broadcast_count !== 0">{{ channel.ended_live_broadcast_count }}</span>
        </td>
        <td v-if="concurrentlyViewerLimitAvailable" class="td__number">
            <span v-if="channel.concurrently_viewer_limit === 0">{{ $t('words.no_limit') }}</span>
            <span v-else-if="channel.concurrently_viewer_limit === -100">{{ $t('words.use_no') }}</span>
            <span v-else>{{ channel.concurrently_viewer_limit }}</span>
        </td>
        <td class="text-center">
            <div v-if="isFileLiveChannel(channel)">
                <span>{{ $t('words.programming_live') }}</span>
            </div>
            <div v-else-if="isWebRtcChannel(channel)">
                <span>WebRTC</span>
            </div>
              <div v-else-if="isCmafChannel(channel)">
                <span>{{ $t('words.cmaf') }}</span>
            </div>
            <div v-else>
                <span>{{ $t('words.mnu_live') }}</span>
            </div>
        </td>
        <td v-if="chattingAvailable" class="text-center">
            <span v-if="channel.use_chatting_service" class="chatting-display is-on"></span>
            <span v-else class="chatting-display"></span></td>
        <td class="text-center">
            <span v-if="channel.status" class="chatting-display is-on"></span>
            <span v-else class="chatting-display"></span></td>
        <td>
            <span class="list__live__title">{{ channel.latest_live_media_broadcast.title }}</span>
            <span class="list__live__creator" v-if="channel.latest_live_media_broadcast.live_creator && channel.latest_live_media_broadcast.live_creator.nickname">{{ channel.latest_live_media_broadcast.live_creator.nickname }}</span>
        </td>
        <td class="td__date">
        <span style="cursor: pointer;" v-tooltip="{ content: channel.latest_live_media_broadcast.interval, html:false }">
            <span v-if="channel.latest_live_media_broadcast.started_at" class="channel__list__date">{{ renderDatetime(channel.latest_live_media_broadcast.started_at) }}</span><span v-if="channel.latest_live_media_broadcast.paused_at" class="channel__list__date">{{ renderDatetime(channel.latest_live_media_broadcast.paused_at) }}</span>
        </span>
        <span class="badge badge__live" v-if="isOnAirByChannel(channel)">{{ $t('words.live_onair') }}</span>
        </td>
        <td class="td__number"><span v-if="showStats">{{ channel.latest_live_media_broadcast.sum_user }}</span></td>
        <td>
            <a @click="showChannelCloningModal(channel)" class="btn-icon-xs">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" class="ic ic-copy">
                    <path d="M10 6H2V14H10V6Z" stroke="currentcolor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="square"/>
                    <path d="M6 2H14V10" stroke="currentcolor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="square"/>
                </svg>
            </a>
        </td>
        <td class="actions">
            <router-link :to="{ name:'cms-channels-edit', params: { channel_id: channel.id } }" class="btn-icon-xs"><i class="icon icon-edit"></i></router-link>
        </td>
    </tr>
</template>

<script>
import GlobalConfigMixin from '../../mixin/GlobalConfigMixin';
import DateTimeMixin from '../../mixin/DateTimeMixin';
import ChannelConfig from './ChannelConfig';

export default {
    name: 'ListItem',

    mixins: [
        GlobalConfigMixin,
        DateTimeMixin,
    ],

    props: {
        channel: {
            type: Object,
            default: () => {},
        },
    },

    data() {
        return {
            showTooltip: false,
        };
    },

    methods: {
        showStats(channel) {
            return channel.getStats && (typeof channel.latest_live_media_broadcast.sum_user !== 'undefined');
        },
        showChannelCloningModal(channel) {
            this.$emit('show-channel-cloning-modal', channel);
        },
        isOnAirByChannel(channel) {
            return typeof channel.latest_live_media_broadcast.is_onair === 'boolean' &&
                channel.latest_live_media_broadcast.is_onair;
        },
        isFileLiveChannel(channel) {
            return parseInt(channel.kind, 10) === ChannelConfig.CHANNEL_KIND.PROGRAMMING;
        },
        isWebRtcChannel(channel) {
            return parseInt(channel.kind, 10) === ChannelConfig.CHANNEL_KIND.WEBRTC;
        },
        isCmafChannel(channel) {
            return parseInt(channel.kind, 10) === ChannelConfig.CHANNEL_KIND.CMAF;
        },
        isDisabledChannel(channel) {
            const isDisabledProgrammingChannel = !this.useFileToLive && channel.kind === 1;
            const isDisabledCmafChannel = !this.useCmaf && channel.kind === 3;
            return isDisabledProgrammingChannel || isDisabledCmafChannel;
        },
        handleMouseEnter() {
            this.showTooltip = true;
        },
        handleMouseLeave() {
            this.showTooltip = false;
        },
    },
};
</script>
